import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import Button from "react-bootstrap/Button";

import { toast } from "react-toastify";
import "./model.css";
import "./addticket.css";
import Tesseract from "tesseract.js";
import { LuClock12 } from "react-icons/lu";
import { LuClock3 } from "react-icons/lu";
import { LuClock6 } from "react-icons/lu";
import { LuClock9 } from "react-icons/lu";
import axiosinstances from "../../Helper/useAxios";
import SHA256 from "crypto-js/sha256";
import { useSelector } from "react-redux";

import UILoader from "../../utils/comman/loader";

import { createdOnDate } from "../../utils/Constant";
import {
  copyTextToClipboard,
  stylesofStype,
  utrLeng,
} from "../../utils/comman/Common";
import UploadFile from "../UploadFile";

// Set app element for react-modal accessibility
Modal.setAppElement("#root");

export default function UpdateUtrAspaymentpage(props) {
  const {
    show,
    handleClose,
    // headers,
    mid,

    dataForUpdateUtr,
    setDataForUpdateUtr,
    reloadTxn,
    updateStatusFromTicketPage,
    txnId,
    userUtr,
  } = props;
  const e = JSON.parse(sessionStorage.getItem("token"));
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const sessionId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.sessionId
  );
  const reqId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.requestId
  );
  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": sessionId,
    "request-id": reqId,
  };
  console.log("mid", mid);
  const [timer, setTimer] = useState(0);
  const salt = process.env.REACT_APP_SALT;
  const [isScreenShootUploaded, setIsScreenShootUploaded] = useState(false);
  const [utr, setUtr] = useState("");
  const [fileName, setFileName] = useState("");
  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const latitude = useSelector((state) => state.userIpAddReducer.latitude);
  const longitude = useSelector((state) => state.userIpAddReducer.longitude);
  const [axiosInstance] = axiosinstances(userIp, latitude, longitude);
  const [loading, setLoading] = useState(false);
  const [attachmentId, setAttachmentId] = useState({});
  console.log("dataForUpdateUtr", dataForUpdateUtr);
  useEffect(() => {
    setUtr("");
    setFileName("");
    return () => {
      setUtr("");
      setFileName("");
    };
  }, [show]);
  //console.log("utr1", utr);

  const fetchUpdatedStatus = async (id) => {
    const url = process.env.REACT_APP_HISTORY;
    var request = {
      mid: mid !== null && mid !== undefined ? mid : "",
      requestId: "",
      orderCode: "",
      txnId: id,
      utr: "",
      vpa: "",
      useUpdatedOn: false,
      fromDate: null,
      toDate: null,
      statusList: [],
      pageNum: 0,
      perPage: 20,
    };
    const response = await axiosInstance
      .post(url, request, { headers })
      .then((res) => {
        if (
          res.data?.transactions !== undefined &&
          Array.isArray(res.data?.transactions)
        ) {
          setDataForUpdateUtr(res.data?.transactions[0]);
          // reloadTxn()
        }
      })
      .catch((err) => {
        console.log(err);
        setDataForUpdateUtr({});

        toast.error("Something went wrong");
      });

    if (response) {
      const result = response.data?.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  useEffect(() => {
    if (updateStatusFromTicketPage && txnId && show) {
      fetchUpdatedStatus(txnId);
    }
  }, [updateStatusFromTicketPage, txnId, show]);

  useEffect(() => {
    if (updateStatusFromTicketPage && userUtr && show) {
      setUtr(userUtr);
    }
  }, [updateStatusFromTicketPage, userUtr, show]);

  useEffect(() => {
    if (!updateStatusFromTicketPage) {
      setUtr(""); // Reset UTR value
      setLoading(false);
    }

    return () => {
      setUtr("");
      setLoading(false);
    };
  }, [show, props.utr]);

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else {
      handleClose();
      if (show) {
        reloadTxn();
      }
    }
  }, [timer]);

  const updateUtr = async () => {
    // e.preventDefault();

    const requestPayload = {};
    const finalUtr = utr;
    if (
      finalUtr === undefined ||
      finalUtr === null ||
      finalUtr.length !== 12 // Check if utr is undefined, null, or the wrong length
    ) {
      toast.error("UTR is not correct"); // Show error toast
      return; // Stop further execution
    }
    const concatRequest = finalUtr + dataForUpdateUtr?.requestId;

    const hashedPassword = generateHash(concatRequest, salt);

    const merchantUpadtePay = "/api/v1/upi/payin/update";
    let url = "";
    url = `${merchantUpadtePay}/${dataForUpdateUtr?.id}/${finalUtr}/${hashedPassword}?idType=txnId`;

    //setDataLoading(true);
    const API_ENDPOINT = url;
    try {
      const response = await axiosInstance.post(API_ENDPOINT, requestPayload, {
        headers,
      });

      if (response.status === 200 && response?.data?.txnId !== undefined) {
        toast.success(`updated utr of ${response?.data?.txnId}`);
        if (attachmentId?.id && fileName) {
          createNewTicket(attachmentId);
        }

        setTimeout(() => {
          fetchUpdatedStatus(response?.data?.txnId);
        }, 100);

        //setDataLoading(false);
        setTimer(4);
      } else {
        //setDataLoading(false);
        throw new Error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      toast.error(error?.message);
      return false;
    }
  };

  const handleSetUtr = (e) => {
    e.preventDefault();
    const value = e.target.value;

    let cleanedValue = value.replace(/[^a-zA-Z0-9]/g, ""); // Remove special characters
    if (dataForUpdateUtr?.transaction?.type == "FT") {
    } else {
      // Further restrict to allow only 12-digit numbers
      cleanedValue = cleanedValue.replace(/\D/g, ""); // Remove non-digit characters
      if (cleanedValue.length > 12) {
        cleanedValue = cleanedValue.slice(0, 12); // Trim to 12 digits max
      }
    }

    setUtr(cleanedValue);
  };

  // setAmount(e.target.value)
  const data = dataForUpdateUtr;

  function generateHash(input, salt) {
    return SHA256(input + salt).toString();
  }
  const containerStyleForupload = {
    // width: "350px",
    padding: "15px",
    border: "1px solid #DADCE0",
    borderRadius: "12px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    marginTop: "1px",
    marginBottom: "5px",
    backgroundColor: "#f9fafb",
    fontFamily: "'Roboto', sans-serif",
  };
  const textRowStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#333",
    fontSize: "16px",
    fontWeight: "500",
  };
  const screenShoothandleFileChange = async (e) => {
    const file = e.target.files[0];

    if (file) {
      setFileName(file.name);
      const res = await uploadFile(file);
      // You can add further logic here (upload or preview)
    }
  };
  const createNewTicket = async (attachmentId) => {
    const todayDate = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD"
    let name = JSON.parse(sessionStorage.getItem("name"));
    const requestPayload = {
      type: "PAY_IN",
      createdBy: name,
      description: `Ticket raised by user while processing the payment${
        attachmentId ? ` (Attachment ID: ${attachmentId?.id})` : ""
      }`,
      userUtr: utr,
      userTxnDate: utr ? todayDate : null,
      comments: null,
      merchantId: mid !== null && mid !== undefined ? mid : "",
      txnId: dataForUpdateUtr?.id,
      attachmentId: attachmentId?.id,
    };

    const API_ENDPOINT = "/api/v1/upi/ticket/create";
    try {
      const response = await axiosInstance.post(API_ENDPOINT, requestPayload, {
        headers,
      });

      if (response.status === 200 && response?.data?.id !== undefined) {
        setIsScreenShootUploaded(true);
        toast.success(
          `Your ticket has raised and ref is ${response?.data?.id}`,
          {
            position: "top-center",
          }
        );
      } else {
        throw new Error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      toast.error(error?.message, {
        position: "top-center",
      });
      return false;
    }
  };
  const handleFileChange = async (file) => {
    const allowedTypes = ["image/jpeg", "image/png", "image/gif"]; // List of allowed MIME types

    if (allowedTypes.includes(file.type)) {
      //  setLoading(true); // Set loading state before processing

      try {
        // Use Tesseract to extract the text
        const {
          data: { text },
        } = await Tesseract.recognize(
          file,
          "eng",
          { logger: (m) => console.log(m) } // Optional logger for progress
        );
        // Use regex to extract the UTR number
        const utrRegex = /\b\d{12}\b/g; // Adjust regex based on your UTR format
        const match = text.match(utrRegex);

        if (match && match.length > 0) {
          // const extractedUtr = match[0]; // Use the first match found
          const extractedUtr = match[match.length - 1];
          setUtr(extractedUtr);
          console.log("extractedUtr", extractedUtr);
          // setTimeout(() => {
          //   updatePayment(extractedUtr);
          // }, 100);
        } else {
          toast.error("UTR not found in the text.", {
            position: "top-center",
          });
        }
      } catch (err) {
        toast.error("Error extracting text: " + err.message);
        console.error("Error extracting text:", err);
      } finally {
        // setLoading(false); // Reset loading state
        // setIsFileLoading(false);
      }
    } else {
      toast.error("Please select a valid image file (JPG, PNG).");
      console.log("Please select a valid image file (JPG, PNG).");
      //setIsFileLoading(false);
    }
  };

  const uploadFile = async (files) => {
    if (!files) {
      console.error("No file selected");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", files);
      const url = "/api/v1/upi/file/upload/1209600";

      const response = await axiosInstance.post(url, formData, { headers });

      if (response.status == 200 && response.data?.id !== undefined) {
        console.log("File uploaded successfully", response.data);
        // Optionally handle response data
        toast.success("File has added", {
          position: "top-center",
        });
        setAttachmentId(response.data);

        handleFileChange(files);
        return response;
      } else {
        toast.error(
          "unable to upload image and file permitted size is 1048576 bytes",
          {
            position: "top-center",
          }
        );
        console.error("Failed to upload file");
      }
    } catch (error) {
      toast.error("Error uploading file:", error, {
        position: "top-center",
      });
      console.error("Error uploading file:", error);
    }
  };

  return (
    <>
      <Modal
        isOpen={show}
        onRequestClose={handleClose}
        contentLabel="Update utr"
        style={{
          content: {
            width: "70%",
            margin: "auto",
            maxHeight: "70vh", // Maximum height of the modal
            overflowY: "auto", // Enable vertical scrolling if content exceeds maxHeight
          },
        }}
      >
        <div>
          <div className="modal-header">
            <h5>UPDATE UTR</h5>
            <button type="button" className="close" onClick={handleClose}>
              {timer == 0 ? (
                <span> &times; </span>
              ) : timer == 1 ? (
                <LuClock3 />
              ) : timer == 2 ? (
                <LuClock6 />
              ) : timer == 3 ? (
                <LuClock9 />
              ) : (
                <span> &times; </span>
              )}
            </button>
          </div>
          <div className="modal-body">
            {loading ? (
              <UILoader />
            ) : (
              <div className="container">
                <div className="row">
                  <div class="col-lg-12 col-md-12 mt-3 desciption">
                    <p class="fw-bold pb-2 m-0">Txn Details</p>
                    <div className="txn-item" key={data?.id}>
                      <div className="txn-head" id="txnhead1">
                        <div
                          className="collapsed"
                          data-bs-toggle="collapse"
                          data-bs-target="#txn1"
                          aria-expanded="false"
                          aria-controls="txn1"
                        >
                          <div
                            className={`txncard ${
                              data?.status === "SUCCESS_AUTO" ||
                              data?.status === "SUCCESS_MANUAL" ||
                              data?.status === "SUCCESS_INCOMPLETE" ||
                              data?.status === "SUCCESS_FROM_FAILED"
                                ? "success grbg"
                                : `${
                                    data?.status === "PENDING_PAYMENT" ||
                                    data?.status === "PAYMENT_PROCESSED" ||
                                    data?.status === "ACCEPTED" ||
                                    data?.status === "TIMEOUT"
                                      ? "pending ylbg"
                                      : "failed rdbg"
                                  }`
                            }`}
                          >
                            <div className="row">
                              <div className="col-12 col-md-2">
                                <div className="txntxt">
                                  <h6>
                                    <span>
                                      {" "}
                                      {data?.createdOn !== undefined &&
                                        data?.createdOn !== null &&
                                        createdOnDate(data?.createdOn)}
                                    </span>{" "}
                                    {/* ₹ {data?.transaction.amount}{" "} */}
                                  </h6>
                                  <h6>{dataForUpdateUtr?.receivingVpa}</h6>
                                </div>
                              </div>
                              <div className={`col-12 col-md-4`}>
                                <div
                                  className="txntxt"
                                  onClick={() =>
                                    copyTextToClipboard(
                                      dataForUpdateUtr?.requestId,
                                      toast
                                    )
                                  }
                                >
                                  <h6>ReqID: {dataForUpdateUtr?.requestId} </h6>
                                </div>
                                <div
                                  className="txntxt"
                                  onClick={() =>
                                    copyTextToClipboard(
                                      dataForUpdateUtr?.id,
                                      toast
                                    )
                                  }
                                >
                                  <h6>TxnID: {dataForUpdateUtr?.id} </h6>
                                </div>
                              </div>

                              <div
                                // className="col-12 col-md-3"
                                className="col-12 col-md-4"
                              >
                                <div className="txntxt">
                                  <h6
                                    onClick={() =>
                                      copyTextToClipboard(
                                        utrLeng(dataForUpdateUtr?.utr),
                                        toast
                                      )
                                    }
                                  >
                                    UTR:{utrLeng(dataForUpdateUtr?.utr)}
                                    {/* <MdContentCopy
                                                    style={{
                                                      color: primaryColor,
                                                    }}
                                                  /> */}
                                  </h6>
                                  <h6
                                    onClick={() =>
                                      copyTextToClipboard(
                                        dataForUpdateUtr?.orderCode,
                                        toast
                                      )
                                    }
                                  >
                                    OrdCode: {dataForUpdateUtr?.orderCode}
                                  </h6>
                                </div>
                              </div>

                              <div className="col-12 col-md-2">
                                <div className="txntxt">
                                  <h4>₹ {"*****"}</h4>

                                  <h4>
                                    <span
                                      className={`${
                                        dataForUpdateUtr?.status ===
                                          "SUCCESS_AUTO" ||
                                        dataForUpdateUtr?.status ===
                                          "SUCCESS_MANUAL" ||
                                        dataForUpdateUtr?.status ===
                                          "SUCCESS_INCOMPLETE" ||
                                        dataForUpdateUtr?.status ===
                                          "SUCCESS_FROM_FAILED"
                                          ? "success"
                                          : `${
                                              dataForUpdateUtr?.status ===
                                                "PENDING_PAYMENT" ||
                                              dataForUpdateUtr?.status ===
                                                "PAYMENT_PROCESSED" ||
                                              dataForUpdateUtr?.status ===
                                                "ACCEPTED" ||
                                              dataForUpdateUtr?.status ===
                                                "TIMEOUT"
                                                ? "pending"
                                                : "failed"
                                            }`
                                      }`}
                                    >
                                      {dataForUpdateUtr?.status}
                                    </span>
                                  </h4>
                                  {/* )} */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Displaying required fields */}
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <div className="col-12 col-md-4 mb-3">
                      <label htmlFor="utr">UTR</label>
                      <input
                        style={{
                          height: "58px",
                          paddingLeft: "10px",
                          border: "1px solid green",
                        }}
                        value={utr}
                        onChange={(e) => handleSetUtr(e)}
                        type="text"
                        name="utr"
                        id="utr"
                        maxLength={12}
                        className="form-control border inputbg border-2"
                      />
                    </div>

                    <div className="col-12 col-md-5 mt-3">
                      {/* <label htmlFor="utr">UTR</label> */}
                      <UploadFile
                        containerStyleForupload={containerStyleForupload}
                        textRowStyle={textRowStyle}
                        screenShoothandleFileChange={
                          screenShoothandleFileChange
                        }
                        fileName={fileName}
                        isScreenShootUploaded={isScreenShootUploaded}
                      />
                    </div>
                  </div>

                  {/* <div
                    className="d-flex flex-column justify-content-center align-items-center"
                    // style={{ minHeight: "300px" }}
                  >
                    <div
                      className="text-secondary mb-3"
                      style={{ fontSize: "14px", fontWeight: "500" }}
                    ></div>

                    <UploadFile
                      containerStyleForupload={containerStyleForupload}
                      textRowStyle={textRowStyle}
                      screenShoothandleFileChange={screenShoothandleFileChange}
                      fileName={fileName}
                      isScreenShootUploaded={isScreenShootUploaded}
                    />
                  </div> */}
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <div
              style={{
                float: "right",
              }}
            >
              {/* Right: Buttons */}
              <div>
                <Button
                  style={{ width: "80px", height: "50px", marginRight: "10px" }}
                  variant="secondary"
                  onClick={handleClose}
                >
                  Close
                </Button>
                <Button
                  style={{ width: "80px", height: "50px" }}
                  variant="primary"
                  onClick={updateUtr}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
